import { gql } from '__generated__';

export const GET_REDIRECT = gql(/* GraphQL */ `
  query getRedirect($input: GetRedirectInput!) {
    getRedirect(getRedirectInput: $input)
  }
`);

export const COGNITO_LOGIN = gql(/* GraphQL */ `
  query cognitoLogin($input: CognitoLoginInput!) {
    cognitoLogin(cognitoLoginInput: $input) {
      success
      error
      data {
        ...AuthSession
      }
      challenge {
        ...AuthChallenge
      }
    }
  }
`);

export const COGNITO_FORGOT_PASSWORD = gql(/* GraphQL */ `
  mutation forgotPassword($input: CognitoForgotPasswordInput!) {
    forgotPassword(cognitoForgotPasswordInput: $input) {
      attributeName
      deliveryMedium
      destination
    }
  }
`);

export const COGNITO_RESET_PASSWORD = gql(/* GraphQL */ `
  mutation resetPassword($input: CognitoResetPasswordInput!) {
    resetPassword(cognitoResetPasswordInput: $input) {
      success
      error
    }
  }
`);
